export function BrandMark({ className = "" }: { className?: string }) {
  return (
    <img
      className={`brand-mark ${className}`.trim()}
      src="/termclear-logo.svg"
      width="52"
      height="52"
      alt=""
      aria-hidden="true"
    />
  );
}
